import Alpine from "alpinejs";
import collapse from "@alpinejs/collapse";
import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

Alpine.plugin(collapse);

// Accordion component
Alpine.data("accordion", (defaultOpen = false) => ({
  open: defaultOpen,

  toggle() {
    this.open = !this.open;
  },

  // Helper to get chevron rotation class
  get chevronClass() {
    return this.open ? "rotate-180" : "";
  },

  // Common content transition attributes (can be overridden)
  contentTransition: {
    "x-show": "open",
    "x-collapse": true,
    "x-transition:enter": "transition ease-out duration-200",
    "x-transition:enter-start": "opacity-0 -translate-y-2",
    "x-transition:enter-end": "opacity-100 translate-y-0",
  },
}));

// Make Alpine available globally
window.Alpine = Alpine;

// Start Alpine
Alpine.start();

// Initialize Swiper for testimonials
document.addEventListener('DOMContentLoaded', () => {
  const testimonialsSwiper = new Swiper('.testimonials-swiper', {
    modules: [Navigation],
    slidesPerView: 1,
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    a11y: {
      prevSlideMessage: 'Previous testimonial',
      nextSlideMessage: 'Next testimonial',
      firstSlideMessage: 'This is the first testimonial',
      lastSlideMessage: 'This is the last testimonial',
    },
  });
});
